import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 4v6.025V10v10zm2 10h3.5a5.7 5.7 0 0 1 1.3-2H7zm0 4h3.175a5.7 5.7 0 0 1-.15-2H7zm-2 4q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 20V4q0-.824.587-1.413A1.93 1.93 0 0 1 5 2h8l6 6v2.5a6 6 0 0 0-.975-.313A8 8 0 0 0 17 10.025V9h-5V4H5v16h6.025q.4.6.9 1.113a6 6 0 0 0 1.1.887z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M21.547 12.934a.904.904 0 0 0-1.308 0l-4.275 4.403-1.73-1.782a.904.904 0 0 0-1.308 0 .97.97 0 0 0 0 1.347l2.384 2.455a.92.92 0 0 0 .654.28.92.92 0 0 0 .654-.28l4.929-5.076a.97.97 0 0 0 0-1.347" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }